import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { useTheme } from "@material-ui/core/styles";
import { Dialog, DialogContent, Grid, Box } from "@material-ui/core";
import translate from "i18n/translate";
import translateIntl from "i18n/translateIntl";
import { ANDROID, IOS, SHOPIFY, NEW_SHOPIFY } from "../../../../../constants";
import {
  getFormValidationScheme,
  validDays,
  inputShouldBeRendered,
} from "../Create/constants";
import { SrAlert, SrButton, SrInput, Typography } from "../../../../common";
import { SrDialogTitle } from "../../../../common/SrDialog";
import ApplicationSquareButton from "../ApplicationSquareButton";
import ShopifyForm from "../ShopifyForm";

const Update = ({ data, onSubmit, handleClose, error }) => {
  const theme = useTheme();
  const open = true;
  const [form, setForm] = useState();

  useEffect(() => {
    const isMobile = data.platform_id === ANDROID || data.platform_id === IOS;
    const isShopify = [SHOPIFY, NEW_SHOPIFY].includes(data.platform_id);

    if (isMobile) {
      setForm({
        platform: data.platform_id,
        applicationBundle: data.application_bundle,
        url: data.callback,
      });
    } else if (isShopify) {
      setForm({
        platform: data.platform_id,
        terms: data.shopify?.url_terms,
        oxxo: data.shopify?.method_oxxo === 1 ? true : false,
        valid: data.shopify?.valid || 0,
        msi: data.shopify?.msi === 1 ? true : false,
      });
    } else {
      // e-commerce
      setForm({
        platform: data.platform_id,
        url: data.callback,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submit = async (values) => {
    await onSubmit({
      form: { ...values, platform: data.platform_id },
      key: data.key,
    });
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      open={open}
    >
      <SrDialogTitle onClose={handleClose}>
        {translate("applications.editApp")}
      </SrDialogTitle>
      <DialogContent>
        <Box
          display="flex"
          width="100%"
          flexDirection="column"
          alignItems="center"
        >
          <Box margin="20px 0">
            <Typography variant="h4Regular">
              {translate("applications.config")}
            </Typography>
          </Box>
          <ApplicationSquareButton
            applicationType={data.platform_id}
            bgcolor={theme.palette.buttonPrimary.main}
          />
        </Box>
        {form && (
          <Formik
            initialValues={{
              ...form,
              applicationName: data.application_name,
              url: data.callback,
            }}
            validationSchema={getFormValidationScheme(data.platform_id, true)}
            onSubmit={submit}
          >
            {({
              errors,
              handleSubmit,
              handleChange,
              handleBlur,
              touched,
              values,
              isSubmitting,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Box maxWidth="356px" marginX="auto" mb={4} mt={3}>
                  <Grid
                    container
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Grid item container justifyContent="flex-start">
                      <Box mb={2}>
                        <Typography variant="h3">
                          {data?.application_name}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid container item spacing={2} direction="column">
                      {[SHOPIFY, NEW_SHOPIFY].includes(form.platform) && (
                        <ShopifyForm
                          handleChange={handleChange}
                          errors={errors}
                          handleBlur={handleBlur}
                          touched={touched}
                          values={values}
                          validDays={validDays}
                          newShopify={form.platform === NEW_SHOPIFY}
                        />
                      )}
                      {Object.keys(form).map((key) => {
                        if (inputShouldBeRendered(key)) {
                          return (
                            <Grid item xs={12}>
                              <SrInput
                                type="text"
                                name={key}
                                key={key}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                label={translateIntl(
                                  `applications.newApp.form.${key}`
                                )}
                                placeholder={translateIntl(
                                  `applications.newApp.form.${key}Placeholder`
                                )}
                                value={values[key]}
                                error={Boolean(errors[key] && touched[key])}
                                helperText={touched[key] && errors[key]}
                                fullWidth
                              />
                            </Grid>
                          );
                        }
                        return undefined;
                      })}
                      {error && (
                        <Grid item xs={12}>
                          <SrAlert severity="error">{error}</SrAlert>
                        </Grid>
                      )}
                      <Grid item xs={12} container spacing={2}>
                        <Grid item>
                          <SrButton
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={isSubmitting}
                          >
                            {translate("common.update")}
                          </SrButton>
                        </Grid>
                        <Grid item>
                          <SrButton
                            onClick={handleClose}
                            disabled={isSubmitting}
                          >
                            {translate("common.cancel")}
                          </SrButton>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </Form>
            )}
          </Formik>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default Update;
